import api from "./api";
import xhr from "xhr";
import validator from "./type_validator";
import getCookie from "./cookies";
import getUrlParameter from "./getUrlParams";
import setOrigin from "./setOrigin";
import TrackingFirstInteraction from "./trackingFirstInteraction";

const contactForms = () => {
  const contactBlocks = document.querySelectorAll(".container__contact-method"),
    currentPage = document.querySelector(".page__form-contact"),
    campaignSlug = currentPage.getAttribute("data-campaign"),
    displayMode = currentPage.getAttribute('data-display-mode'),
    campaignFormSlug = currentPage.getAttribute("data-form"),
    vehicule_id = currentPage.getAttribute("data-id"),
    submitBtn = document.querySelector('button[type="submit"]');

  return {
    toggleCustomerInformationBlock: () => {
      let isCustomerRadios = document.querySelectorAll('input[type="radio"][name="customer"]');
      const customerContainer = document.querySelector('.form__input-container__is_customer');
      isCustomerRadios.forEach(input => {
        input.addEventListener('change', e => {
          if (e.currentTarget.value === 'yes') {
            customerContainer.classList.remove('hidden');
          } else {
            customerContainer.classList.add('hidden');
          }
        })
      })
    },
    toggleBlock: () => {
      contactBlocks.forEach(elem => {
        let title = elem.querySelector(".contact-method--title");
        title.addEventListener("click", e => {
          var tfi = new TrackingFirstInteraction()
          tfi.triggerFirstInteraction();
          if (!elem.classList.contains("open")) {
            elem.classList.add("open");
          } else {
            elem.classList.remove("open");
          }
        });
      });
    },
    formSubmission: () => {
      let payload = {
        origin: `${setOrigin()}`,
        campaign_id: currentPage.getAttribute("data-campaign-id"),
        tl: currentPage.getAttribute("data-tl"),
        lead: {
          firstname: document.querySelector("#firstname").value,
          lastname: document.querySelector("#lastname").value,
          civility: document
            .querySelector(".civility-label")
            .getAttribute("data-value"),
          email: document.querySelector("#email").value,
          response_type: document
            .querySelector("#mail-object")
            .getAttribute("data-id"),
          message: document.querySelector(".form__input--message").value
        },
        dealer: {
          id: document.getElementById('dealerId') ? document.getElementById('dealerId').value : ''
        },
        consents: {
          purpose: currentPage.getAttribute("data-purpose"),
          policy_name: currentPage.getAttribute("data-policy-name"),
          policy_version: currentPage.getAttribute("data-policy-version"),
          consentMarketing: document.querySelector("#consentMarketing") && document.querySelector("#consentMarketing").checked ? "1" : "0",
          consent: document.querySelector("#consentGeneral") && document.querySelector("#consentGeneral").checked ? "1" : "0"
        },
        preview: window.location.href.indexOf("preview") >= 0 ? "1" : "0",
        transaction_id: currentPage.getAttribute("data-transaction-id"),
        offer_id: currentPage.getAttribute("data-offer-id")
      };

      let requestParams = `${window.location.search.slice(1)}`;
      let link = "";

      // On vérifie le besoin d'envoyer les informations client, si visiteur est déjà client
      let isCustomer = false;
      let isCustomerRadios = document.querySelectorAll('input[type="radio"][name="customer"]');
      for(let i=0; i < isCustomerRadios.length; i++) {
        if (isCustomerRadios[i].checked && isCustomerRadios[i].value==='yes') {
          isCustomer = true;
          break;
        }
      }

      if (isCustomer) {
        let serialNumberField = document.querySelector('input[name="serialnumber"]');
        if (serialNumberField) {
          payload.serial_number = serialNumberField.value;
        }
        let caseNumberField = document.querySelector('input[name="casenumber"]');
        if (caseNumberField) {
          payload.case_number = caseNumberField.value;
        }
      }
    
      if(typeof confirmUrl !== 'undefined') {
        link = `${api().bmw}` +  confirmUrl.replace(api().appPrefix, '');
        if (requestParams) {
          link = link + '?' + requestParams;
        }
      } else {
        link = `${api().bmw}/${campaignSlug}/${campaignFormSlug}/confirm`;
        if (displayMode) {
          link += '/'+displayMode;
        }
        if (requestParams) {
          link += '?'+requestParams;
        }
      }
      console.log('link',link);
      xhr(
        {
          method: "POST",
          body: JSON.stringify(payload),
          uri: `${
          api().bmw
          }/${campaignSlug}/${campaignFormSlug}/${vehicule_id}/validate`,
          headers: {
            "Content-Type": "application/json"
          },
          "Access-Control-Allow-Origin": `${
          api().bmw
          }/${campaignSlug}/${campaignFormSlug}/${vehicule_id}/validate`
        },
        (err, resp, body) => {
          let data = JSON.parse(body);
          if (data.status == "ok") {
            if(typeof _satellite != 'undefined') _satellite.track ('FormConfirmed')
            // dataLayer.push(payload);
            if (requestParams) {
              window.location.href = `${link}`  + '&hash=' + data.hash;
            } else {
              window.location.href = `${link}`  + '?hash=' + data.hash;
            }
          } else {
            const res = JSON.parse(resp.body);
            for (const key in res) {
              if (res.hasOwnProperty(key)) {
                const element = res[key];
                if (element === false) {
                  let falseInput = document.getElementById(`${key}`);
                  falseInput.parentElement.classList.add("error");
                  validator().showErrorMsg(falseInput);
                }
              }
            }
            submitBtn.classList.remove("disabled");
            submitBtn.disabled = false;
          }
        }
      );
    }
  };
};
export default contactForms;
